import { Http } from '../../../../../../helpers/axois';
import { Token } from './types';

type AddTokenPayload = {
	name: string;
	branchId: string;
};

export const api = {
	async getTokens(appId: string, branchId: string) {
		try {
			const path = baseURL(appId) + `?branchId=${branchId}`;
			const tokens: unknown = await Http.get(path).toPromise();
			return tokens as Token[];
		} catch (err) {
			throw err;
		}
	},

	async addToken(appId: string, payload: AddTokenPayload) {
		try {
			const path = baseURL(appId);
			const res = await Http.post(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async deleteToken(appId: string, branchId: string, tokenId: string) {
		try {
			const path = baseURL(appId) + `/${tokenId}?branchId=${branchId}`;
			await Http.delete(path).toPromise();
		} catch (err) {
			throw err;
		}
	},
};

function baseURL(appId: string) {
	return `/apps/${appId}/chat-nlu/excludedTokens`;
}
